// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import OldStudentProfileLayout from './OldStudentProfileLayout';

import EleveService from '../../services/EleveService';

const DeleteOldStudent = () => {
	const [old_student, setOldStudent] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([EleveService.getEleve(id)]).then(([eleveData]) => {
			setOldStudent(eleveData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the EleveService to delete the old_student
			await EleveService.deleteEleve(id);

			// Redirect the user to the list of old_students
			navigate('/archives/eleves');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations de l'élève",
				error
			);
		}
	};

	return (
		<OldStudentProfileLayout>
			{old_student && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">
											{old_student.nom || ''}
										</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement le profil de cet ancien élève.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez le profil de cet ancien élève, toutes les
									données le concernant seront définitivement supprimées.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le profil de cet ancien élève
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</OldStudentProfileLayout>
	);
};

export default DeleteOldStudent;
